import { FC } from 'react';

import { x } from '@/style';

export const TextLayoutContainer: FC = ({ children }) => (
  <x.div display='flex' flexDirection='column' flex='1'>
    {children}
  </x.div>
);
